import { render, staticRenderFns } from "./performances_tab.vue?vue&type=template&id=ba03bcf0"
import script from "./performances_tab.vue?vue&type=script&lang=js"
export * from "./performances_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports